import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, StaticQuery } from "gatsby";

import "../css/tachyons.min.css";
import "../css/markdown-styles.css";
import "../css/site.css";

import AlertBar from '../components/AlertBar';
import HeroNavBar from '../components/HeroNavBar';
import MainNavBar from '../components/MainNavBar';
import Footer from '../components/Footer';

export default function PagesTemplateWithData(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          file {
            publicURL
          }
        }
      `}
      render={data => <PagesTemplate data={data} {...props} />}
    />
  )
}

class PagesTemplate extends Component {
  render() {
    console.log('DATA IS:', this.props.data);
    const navBar = this.props.showHero ? <HeroNavBar /> : <MainNavBar />;

    return (
      <div className="avenir">
        <AlertBar />

        {navBar}

        <div>{this.props.children}</div>

        <Footer />
      </div>
    );
  }
}

PagesTemplate.propTypes = {
  children: PropTypes.any,
  showHero: PropTypes.bool,
};

PagesTemplate.defaultProps = {
  showHero: false
}
